import React from "react";
import { useSelector } from "react-redux";

export const ProgressBar = () => {
  const progressbarOptions = useSelector(
    (state) => state.progressbarReducer.options
  );
  const { percent, lightGreenStripe, greenStripe } = progressbarOptions;

  return (
    <div className="col-md-6 header-calc-col-progressbar md-hide">
      <div className="header-calc-title">
        <div className="header-calc-title-in">
          <span>Уже заполнено</span>
        </div>
        <div className="header-calc-title-in">
          <div className="bold">{percent} %</div>
        </div>
      </div>
      <div className="progressbar">
        <div
          className="progressbar-scale"
          style={{
            width: `${lightGreenStripe}%`,
          }}
        />
        <div className="circle" style={{ width: `${greenStripe}%` }} />
      </div>
    </div>
  );
};
